import Button from '@liquidweb-dev/undercurrent/Button';
import EmptyState from '@liquidweb-dev/undercurrent/EmptyState';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import StandardErrorState from 'components/ErrorState';
import LoaderCircleIcon from '@liquidweb-dev/undercurrent/icons/animated/LoaderCircle';
import NotepadTextIcon from '@liquidweb-dev/undercurrent/icons/lucide/NotepadText';

const EmptyStateWrapper = (props: StackProps) => (
	<Stack
		sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}
		{...props}
	/>
);

export interface ErrorStateProps {
	onRetry: () => void;
}

export const ErrorState = ({ onRetry }: ErrorStateProps) => (
	<EmptyStateWrapper>
		<StandardErrorState onTryAgain={onRetry}>
			A problem occurred while loading your secure notes
		</StandardErrorState>
	</EmptyStateWrapper>
);

export const Loading = () => (
	<EmptyStateWrapper>
		<EmptyState
			icon={
				<LoaderCircleIcon
					sx={({ size }) => ({
						height: size.md,
						width: size.md,
					})}
				/>
			}
			sx={{ maxWidth: '264px' }}
		>
			Gathering your secure notes...
		</EmptyState>
	</EmptyStateWrapper>
);

export interface EmptyProps {
	onNewNoteClick: () => void;
}

export const Empty = ({ onNewNoteClick }: EmptyProps) => (
	<EmptyStateWrapper>
		<EmptyState
			icon={
				<NotepadTextIcon
					sx={({ size }) => ({
						height: size.md,
						width: size.md,
					})}
				/>
			}
			primaryButton={
				<Button color="highlight" onClick={onNewNoteClick}>
					Create a note
				</Button>
			}
			sx={{ maxWidth: '264px' }}
		>
			You don’t have any secure notes
		</EmptyState>
	</EmptyStateWrapper>
);
